import React from 'react';
import { ClockIcon, MailIcon, MapPinIcon, MessageSquareIcon, NavigationIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
export function ContactPanel() {
  const {
    t
  } = useLanguage();
  return <div className="grid gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-93" data-mp="1js91czfxkyc2">
      <div data-id="element-94" data-mp="1xt1txemo9jcj">
        <dl className="space-y-7" data-id="element-95" data-mp="1xsjr1z5i86vn">
          <div className="flex gap-4" data-id="element-96" data-mp="1xrqvlubzx3st">
            <MapPinIcon width={22} height={22} aria-hidden="true" className="mt-0.5 shrink-0 text-gold-600" data-id="element-97" data-mp="1sus3fhbw76x9" />
            <div data-id="element-98" data-mp="27l7mapgu62s9">
              <dt className="text-sm font-bold uppercase tracking-wide text-navy-500" data-id="element-99" data-mp="22kjzkfzn483u">
                {t(copy.contactHome.addressLabel)}
              </dt>
              <dd className="mt-1 text-lg font-medium text-navy-900" data-id="element-100" data-mp="2gkcj9rcr1o2b">
                {business.address}
                <span className="block" data-id="element-101" data-mp="2biwze2mb5nli">{business.cityState}</span>
              </dd>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-102" data-mp="3oud8c874g6qj">
            <PhoneIcon width={22} height={22} aria-hidden="true" className="mt-0.5 shrink-0 text-gold-600" data-id="element-103" data-mp="3ovejsds1uv8s" />
            <div data-id="element-104" data-mp="2mvdrkizdwpv">
              <dt className="text-sm font-bold uppercase tracking-wide text-navy-500" data-id="element-105" data-mp="2newv4kdar5h">
                {t(copy.contactHome.phoneLabel)}
              </dt>
              <dd className="mt-1" data-id="element-106" data-mp="6mw4a3jctyda">
                <a href={business.phoneHref} className="font-display text-2xl font-bold text-navy-900 hover:text-gold-600" data-id="element-107" data-mp="bn1r96eoiwp1">
                  {business.phoneDisplay}
                </a>
              </dd>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-108" data-mp="qd9avpgfalrb">
            <ClockIcon width={22} height={22} aria-hidden="true" className="mt-0.5 shrink-0 text-gold-600" data-id="element-109" data-mp="qeaoo1otpmcq" />
            <div className="w-full max-w-sm" data-id="element-110" data-mp="2rg0fjejd2ia5">
              <dt className="text-sm font-bold uppercase tracking-wide text-navy-500" data-id="element-111" data-mp="2rckxc2ue4t4i">
                {t(copy.contactHome.hoursLabel)}
              </dt>
              <dd className="mt-2 divide-y divide-navy-100 border-y border-navy-100" data-id="element-112" data-mp="308ansqap4dor">
                {business.hours.map(entry => <p key={entry.days.en} className="flex items-center justify-between gap-6 py-2 text-navy-800" data-id="element-113" data-mp="2vefz18g8h8it">
                    <span className="font-medium" data-id="element-114" data-mp="355kee99tmve6">{t(entry.days)}</span>
                    <span className={entry.closed ? 'text-navy-500' : 'font-semibold'} data-id="element-115" data-mp="3j6em0pp1osbs">
                      {t(entry.time)}
                    </span>
                  </p>)}
              </dd>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-116" data-mp="1ks38m3rn06l8">
            <MailIcon width={22} height={22} aria-hidden="true" className="mt-0.5 shrink-0 text-gold-600" data-id="element-117" data-mp="1amk1h1cxal0z" />
            <div data-id="element-118" data-mp="1eq9o3la1esjd">
              <dt className="text-sm font-bold uppercase tracking-wide text-navy-500" data-id="element-119" data-mp="10ws4k0hcpftc">
                {t(copy.contactHome.emailLabel)}
              </dt>
              <dd className="mt-1" data-id="element-120" data-mp="15uahs32eih75">
                <a href={`mailto:${business.email}`} className="font-medium text-navy-900 hover:text-gold-600" data-id="element-121" data-mp="15tio4xsd6tji">
                  {business.email}
                </a>
              </dd>
            </div>
          </div>
        </dl>

        <div className="mt-9 grid gap-3 sm:grid-cols-3" data-id="element-122" data-mp="hzzdmavnor26">
          <a href={business.phoneHref} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md bg-navy-900 px-4 font-bold text-white transition-colors duration-150 ease-smooth hover:bg-navy-800" data-id="element-123" data-mp="my0uqq9iugb0">
            <PhoneIcon width={17} height={17} aria-hidden="true" data-id="element-124" data-mp="2h8o2iz1uygiy" />
            {t(copy.cta.callNow)}
          </a>
          <a href={business.directionsUrl} target="_blank" rel="noreferrer" className="flex min-h-[48px] items-center justify-center gap-2 rounded-md bg-gold-500 px-4 font-bold text-navy-950 transition-colors duration-150 ease-smooth hover:bg-gold-400" data-id="element-125" data-mp="c9oa4hfnb6bf">
            <NavigationIcon width={17} height={17} aria-hidden="true" data-id="element-126" data-mp="3ufsxoroyj73l" />
            {t(copy.cta.directionsShort)}
          </a>
          <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex min-h-[48px] items-center justify-center gap-2 rounded-md border border-navy-200 px-4 font-bold text-navy-900 transition-colors duration-150 ease-smooth hover:bg-navy-50" data-id="element-127" data-mp="3pnsqce6k5bwz">
            <MessageSquareIcon width={17} height={17} aria-hidden="true" data-id="element-128" data-mp="3bo01ypii77s6" />
            {t(copy.cta.whatsapp)}
          </a>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl ring-1 ring-navy-100" data-id="element-129" data-mp="1m87934b62yhf">
        <iframe title={t(copy.contactHome.mapLabel)} src={business.mapEmbedUrl} className="h-[340px] w-full lg:h-full lg:min-h-[420px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-130" data-mp="1ma0fcihvbgow" />
      </div>
    </div>;
}